import React from 'react';
import ImageEuro from '@material-ui/icons/EuroSymbol'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import PropTypes from 'prop-types';
import {formatPrice} from "../utils/commonFunctions";

const EditPracticeSidebar = ({preview, selectedServiceIds = []}) => {

    // showZero=true  -> mostra sempre l'importo, anche se 0,00 € (righe selezionate, prezzo base/totale)
    // showZero=false -> se il prezzo è 0 mostra i trattini (riga NON selezionata)
    const renderPrice = (label, value, showZero = true, variant = '') => {
        const showAmount = value || (showZero && Number.isFinite(value));
        return <React.Fragment>
            <dt className={variant}>{label}:</dt>
            {' '}
            <dd className={variant}>
                {`${showAmount ? formatPrice(value) : '-,--'}`}
            </dd>
        </React.Fragment>;
    };

    const isRowSelected = (row) =>
        selectedServiceIds.map(Number).includes(Number(row.id));

    return (
        <Grid className="form-sidebar fixed aside-booking">
            <List className="aside-list">
                <div className="aside-panel">
                    <ListItem className="aside-title">
                        <ListItemAvatar>
                            <Avatar className="highlight-color">
                                <ImageEuro/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Riepilogo"/>
                    </ListItem>

                    {
                        preview && <ListItem className="aside-content">
                            <dl className="price-si">
                                <div className="price-specs">
                                    {renderPrice("Prezzo base", preview.basePrice)}
                                    {preview.rows?.map((row) => renderPrice(row.name || row.description, row.price, isRowSelected(row)))}
                                    {renderPrice("Prezzo totale", preview.totalPrice, true, "price-total")}
                                </div>
                            </dl>
                        </ListItem>
                    }
                </div>

            </List>
        </Grid>
    );
};

EditPracticeSidebar.propTypes = {
    preview: PropTypes.object.isRequired,
    selectedServiceIds: PropTypes.array,
};

export default EditPracticeSidebar;
